/* eslint-disable react-hooks/rules-of-hooks */
import { ReactReduxContext } from 'react-redux';
import { useContext } from 'react';
import { useWtrSelector } from '../redux/hooks';
import {
  getDeliveryMinimumOrderValueAmount,
  getMinimumSpendThresholdMet,
} from '../redux/modules/trolley/selectors/get-totals';
import { hasBookedSlot, getSlotType } from '../redux/modules/customer-slot/selectors';
import { SlotTypes } from '../constants/fulfilmentTypes';

export function useMinSpend() {
  const reduxContext = useContext(ReactReduxContext);
  const state = reduxContext?.store?.getState();

  if (!state) {
    return {
      minSpend: 0,
      showMinSpend: false,
    };
  }

  const minSpend = useWtrSelector(getDeliveryMinimumOrderValueAmount) || 0;

  const minSpendThresholdPassed = useWtrSelector(getMinimumSpendThresholdMet) || false;
  const isSlotBooked = useWtrSelector(hasBookedSlot) || false;
  const slotType = useWtrSelector(getSlotType);

  return {
    minSpend,
    showMinSpend:
      minSpendThresholdPassed !== undefined &&
      !minSpendThresholdPassed &&
      isSlotBooked &&
      slotType !== SlotTypes.ENTERTAINING_COLLECTION &&
      slotType !== SlotTypes.UNDEFINED,
  };
}
